/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Shalani Chethana
 * @Date 11/03/2025
 */

import React from 'react'
import ServiceBox from "../components/servicePages/serviceBox";
import { Typography} from '@mui/material';
import ContactBtnDialog from "../components/contact/contactBtnDialog"

import Styles from "./services.module.css"

const Services = () => {
    return (

        <>
        <div className={Styles.videoCompOuterBox}>
        <video autoPlay muted loop id="myVideo" className={Styles.videoComp}>
          <source src="https://n-ach-file-directory.sgp1.cdn.digitaloceanspaces.com/N_ACH_WEBSITE/N-ach_official_web/videos/servicesBackground.mp4" type="video/mp4" />
        </video>
        <div className={Styles.videoBackgroundBox}>
          <Typography variant='body1' className={Styles.videoBackgroundText}>We have put together a special combination of strategy,
            marketing, design, and digital expertise for your Need for Achievement, design, and digital expertise for your Need for Achievement
          </Typography>
          <ContactBtnDialog />
        </div>
      </div>
            <div >
                <div className={Styles.outerContainerHeader}>
                    <Typography variant='h5' className={Styles.titelFirsttxt} >Our Services</Typography>
                    <Typography variant='h4' className={Styles.mainHeadertxt}>Supporting Your Growth</Typography>
                    <Typography variant='body1' className={Styles.contentBodytxt}> We offer software services through offshore development teams,
                        scoped projects and onsite consultants in Sweden. Our most popular Extended Teams model is great for expanding your development team in a cost efficient and qualitative manner,
                        while a project can be the perfect way to get started.
                        Our onsite consultants are high-performing engineers who join your project at your location, for an even closer collaboration.
                    </Typography>
                </div>

                <ServiceBox />
                <div>
                    <div>

                    </div>
                    <div>
                    
                    </div>
                </div>
            </div>
        </>

    )
}

export default Services